<template>
    <div>
        <div class="modal-small-toolbar">
            <span>User Information</span>
        </div>
        <form>
            <div class="flex flex-col p-4">
            	<div class="flex">
	                <div class="flex flex-1 flex-col bg-gray-50 max-w-2xl shadow-md rounded-sm p-6 border border-gray-300">
                        <div class="flex flex-col">
                            <div class="flex justify-between mb-4">
                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="name">Name</label>
                                    <input type="text" name="name" class="form-input w-full" v-model="users.selectedUser.name">
                                    <div v-if="errors.name" class="form-error">{{ errors.name[0] }}</div>
                                </div>

                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="role_id">Role</label>
                                    <select v-model="users.selectedUser.role_id" class="form-select w-full">
                                        <option value=""></option>
                                        <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.label }}</option>
                                    </select>
                                    <div v-if="errors.role_id" class="form-error">{{ errors.role_id[0] }}</div>
                                </div>
                            </div>

                            <div class="flex justify-between mb-4">
                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="department">Department</label>
                                    <input type="text" name="department" maxlength="100" class="form-input w-full" v-model="users.selectedUser.department">
                                    <div v-if="errors.department" class="form-error">{{ errors.department[0] }}</div>
                                </div>

                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="title">Job Title</label>
                                    <input type="text" name="title" class="form-input w-full" v-model="users.selectedUser.title">
                                    <div v-if="errors.title" class="form-error">{{ errors.title[0] }}</div>
                                </div>
                            </div>

                            <div class="flex justify-between mb-4">
                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="email">Email</label>
                                    <div class="flex items-center">
                                        <inline-svg name="email" classes="absolute fill-current text-gray-600 w-3 h-3 mx-3"></inline-svg>
                                        <input type="text" name="email" class="form-input w-full pl-8" v-model="users.selectedUser.email">
                                    </div>
                                    <div v-if="errors.email" class="form-error">{{ errors.email[0] }}</div>
                                </div>
                            </div>

                            <div v-if="resetPassword || users.selectedUser.id == 'new'" class="flex justify-between mb-4">
                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="password">Password</label>
                                    <div class="relative flex items-center">
                                        <inline-svg name="key" classes="absolute fill-current text-gray-600 w-3 h-3 mx-3"></inline-svg>
                                        <input type="password" name="password" class="form-input w-full pl-8" v-model="users.selectedUser.password" required>
                                    </div>
                                    <div v-if="errors.password" class="form-error">{{ errors.password[0] }}</div>
                                </div>

                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="password_confirmation">Confirm Password</label>
                                    <div class="flex items-center">
                                        <inline-svg name="key" classes="absolute fill-current text-gray-600 w-3 h-3 mx-3"></inline-svg>
                                        <input type="password" name="password_confirmation" class="form-input w-full pl-8" v-model="users.selectedUser.password_confirmation" required>
                                    </div>
                                </div>
                            </div>

                            <div class="flex justify-between mb-4">
                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="phone">Phone</label>
                                    <div class="flex items-center">
                                        <inline-svg name="phone" classes="absolute fill-current text-gray-600 w-3 h-3 mx-3"></inline-svg>
                                        <input type="text" name="phone" maxlength="15" class="form-input w-full pl-8" v-model="users.selectedUser.phone">
                                    </div>
                                    <div v-if="errors.phone" class="form-error">{{ errors.phone[0] }}</div>
                                </div>

                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="extension">Phone Extension</label>
                                    <input type="text" name="extension" pattern="^[0-9]*" inputmode="numeric" maxlength="5" class="form-input w-full" v-model="users.selectedUser.extension">
                                    <div v-if="errors.extension" class="form-error">{{ errors.extension[0] }}</div>
                                </div>
                            </div>

                            <div class="flex justify-between mb-4">
                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="cell">Cell</label>
                                    <div class="flex items-center">
                                        <inline-svg name="phone" classes="absolute fill-current text-gray-600 w-3 h-3 mx-3"></inline-svg>
                                        <input type="text" name="cell" maxlength="15" class="form-input w-full pl-8" v-model="users.selectedUser.cell">
                                    </div>
                                    <div v-if="errors.cell" class="form-error">{{ errors.cell[0] }}</div>
                                </div>

                                <div class="flex-1 mr-4">
                                    <label class="block text-sm mb-2" for="cell_carrier_id">Cell Carrier</label>
                                    <select v-model="users.selectedUser.cell_carrier_id" class="form-select w-full">
                                        <option value=""></option>
                                        <option v-for="carrier in cellCarriers" :key="carrier.id" :value="carrier.id">{{ carrier.carrier }}</option>
                                    </select>
                                    <div v-if="errors.cell_carrier_id" class="form-error">{{ errors.cell_carrier_id[0] }}</div>
                                </div>
                            </div>

                            <div class="flex justify-between mb-4">
                                <div class="flex-1 mr-4">
                                    <label for="country_id" class="block text-sm mb-2">Country</label>
                                    <select v-model="users.selectedUser.country_id" class="form-select w-full">
                                        <option
                                            v-for="country in countries" :key="country.id"
                                            :value="country.id">
                                                {{ country.name }}
                                        </option>
                                    </select>
                                    <div v-if="errors.country_id" class="form-error">{{ errors.country_id[0] }}</div>
                                </div>
                            </div>
                        </div>
	                </div>
				</div>

                <!-- 2FA Status Section -->
                <div v-if="($gate.isAdmin() || $gate.isClientAdmin()) && users.selectedUser.id != 'new'" class="mt-4">
                    <div class="bg-blue-50 border border-blue-200 rounded-sm p-4">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center">
                                <inline-svg name="locked" classes="w-5 h-5 text-blue-600 mr-2"></inline-svg>
                                <span class="font-medium text-blue-900">Two-Factor Authentication Status</span>
                            </div>
                            <span
                                :class="{
                                    'px-3 py-1 rounded text-sm font-medium': true,
                                    'bg-green-100 text-green-800': users.selectedUser.is_2fa_enabled,
                                    'bg-red-100 text-red-800': !users.selectedUser.is_2fa_enabled,
                                    'bg-yellow-100 text-yellow-800': users.selectedUser.is_2fa_enabled && !users.selectedUser.two_fa_method
                                }"
                            >
                                {{ users.selectedUser.two_fa_status }}
                            </span>
                        </div>
                        <div class="mt-2 text-sm text-blue-700">
                            <p v-if="users.selectedUser.is_2fa_enabled && users.selectedUser.two_fa_method">
                                User has 2FA enabled using {{ get2FAMethodText() }}. They will be required to complete 2FA verification on login.
                            </p>
                            <p v-else-if="users.selectedUser.is_2fa_enabled && !users.selectedUser.two_fa_method">
                                User has 2FA enabled but not yet configured. They will need to complete 2FA setup on their next login.
                            </p>
                            <p v-else>
                                User has 2FA disabled. They can login without 2FA verification.
                            </p>
                        </div>
                    </div>
                </div>

                <div class="flex justify-between mt-4">
                    <div class="space-x-3">
                        <button
                            type="button"
                            v-if="users.selectedUser.id != 'new'"
                            @click="resetPassword = true"
                            class="btn btn-small btn-blue">
                                Reset Password
                        </button>

                        <button
                            type="button"
                            v-if="($gate.isAdmin() || $gate.isClientAdmin()) && users.selectedUser.id != 'new'"
                            @click="toggle2FA"
                            :disabled="toggling2FA"
                            :class="{
                                'btn btn-small': true,
                                'btn-green': !users.selectedUser.is_2fa_enabled,
                                'btn-red': users.selectedUser.is_2fa_enabled,
                                'opacity-50 cursor-not-allowed': toggling2FA
                            }">
                            <span v-if="toggling2FA">
                                <inline-svg name="loading-button" classes="w-4 h-4"></inline-svg>
                            </span>
                            <span v-else>
                                {{ users.selectedUser.is_2fa_enabled ? 'Disable 2FA' : 'Enable 2FA' }}
                            </span>
                        </button>

                        <button
                            type="button"
                            v-if="($gate.isAdmin() || $gate.isClientAdmin()) && users.selectedUser.id != 'new'"
                            @click="confirmDeleteUser"
                            class="btn btn-small btn-red">
                                Delete User
                        </button>
                    </div>

                    <div>
                    	<button type="button" class="btn btn-green" @click="save">
        	                <span v-if="loading">
        	                    <inline-svg name="loading-button"></inline-svg>
        	                </span>
        	                <span v-else>Save</span>
        	            </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                roles: '',
                cellCarriers: '',
                countries: '',

                resetPassword: false,
                loading: false,
                errors: {},
                toggling2FA: false
            }
        },

        created() {
            // pull countries
            axios.get('/api/countries').then((response) => {
                this.countries = response.data;
            }).catch((error) => {
                console.log(error);
            });

            // pull roles
            axios.get('/api/roles').then((response) => {
                this.roles = response.data;
            }).catch((error) => {
                console.log(error);
            });

            // pull cell carriers
            axios.get('/api/cell-carriers').then((response) => {
                this.cellCarriers = response.data;
            }).catch((error) => {
                console.log(error);
            });
        },

        watch: {
            'users.selectedUser.id': {
                handler() {
                    this.resetPassword = false;
                }
            }
        },

        computed: {
        	...mapState(['users'])
        },

        methods: {
            removeUser() {
                this.users.all = _.remove(this.users.all, (user) => {
                    return user.id == this.users.selectedUser.id
                });

                this.users.selectedUser.id = null;
            },

            confirmDeleteUser() {
                if (this.users.selectedUser.id == "new") {
                    this.removeUser();

                    return;
                }

                this.$swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to delete this User?",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteUser();
                    }
                });
            },

            deleteUser() {
                axios.delete('/users/' + this.users.selectedUser.id)
                    .then((response) => {
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });

                        this.$eventHub.$emit('reloadClient');
                    })
                    .catch((error) => {
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response.data.message
                        });
                    }
                );
            },

        	save() {
                this.loading = true;

                const method = this.users.selectedUser.id === 'new' ? 'post' : 'put';
                const url = method === 'post' 
                    ? '/users' 
                    : `/users/${this.users.selectedUser.id}`;
                
                axios[method](url, this.users.selectedUser)
                    .then(response => {
                        _.merge(this.users.selectedUser, response.data.user);
                        this.errors = {};

                    this.errors = '';

                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: response.data.message
                    });

                        this.$eventHub.$emit('reloadClient');
                    })
                    .catch(error => {
                        console.log('error', error);
                        if (error?.response) {
                            this.$notify({
                                type: 'error',
                                title: 'Error',
                                text: error.response.data?.message || 'An error occurred while processing your request.'
                            });
                        } else {
                            this.$notify({
                                type: 'error',
                                title: 'Network Error',
                                text: 'Unable to connect to the server. Please check your connection.'
                            });
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        	},

            toggle2FA() {
                this.toggling2FA = true;
                const formData = new FormData();
                // Use 1 for true, 0 for false
                formData.append('enable', !this.users.selectedUser.is_2fa_enabled ? 1 : 0);

                axios.post('/users/' + this.users.selectedUser.id + '/toggle-2fa', formData)
                    .then((response) => {
                        this.users.selectedUser.is_2fa_enabled = response.data.user.is_2fa_enabled;
                        this.users.selectedUser.two_fa_method = response.data.user.two_fa_method;
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                        this.$eventHub.$emit('reloadClient');
                    })
                    .catch((error) => {
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response?.data?.message || 'Failed to update 2FA status. Please try again.'
                        });
                    })
                    .finally(() => {
                        this.toggling2FA = false;
                    });
            },

            get2FAStatusText() {
                if (this.users.selectedUser.is_2fa_enabled && this.users.selectedUser.two_fa_method) {
                    return 'Enabled';
                } else if (this.users.selectedUser.is_2fa_enabled && !this.users.selectedUser.two_fa_method) {
                    return 'Enabled (Not Configured)';
                } else {
                    return 'Disabled';
                }
            },

            get2FAMethodText() {
                if (this.users.selectedUser.is_2fa_enabled && this.users.selectedUser.two_fa_method) {
                    return this.users.selectedUser.two_fa_method;
                } else {
                    return 'Not Configured';
                }
            }
        }
    }
</script>
